export const AI_CONTENT_FEEDBACK_RATINGS = {
  LIKE: 'LIKE',
  DISLIKE: 'DISLIKE',
}
